export const NEW_UNACADEMY_GIF = 'careers/newUnacademy.gif';
export const DARWINBOX_URL =
  'https://unacademy.darwinbox.in/ms/candidate/careers';
export const PUBLIC_NOTICE_URL = 'careers/public-notice';
